<script setup lang="ts">
import { stats } from '../../../content'
</script>

<template>
  <section id="stats" class="stats">
    <div class="container">
      <div class="grid grid--4">
        <div
          v-for="(stat, index) in stats"
          :key="stat.label"
          class="stat-card animate animate--fade-up"
          :class="`animate--delay-${index + 1}`"
        >
          <div class="stat-card__icon">
            <svg v-if="stat.icon === 'icon-computer-screen-1'" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/>
            </svg>
            <svg v-else-if="stat.icon === 'icon-business-briefcase-cash'" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2m6 6v2m-4-2v2"/>
            </svg>
            <svg v-else-if="stat.icon === 'icon-timer-4'" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
            </svg>
            <svg v-else-if="stat.icon === 'icon-rewards-medal-1'" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="8" r="6"/><path d="M15.5 14.5L17 22l-5-3-5 3 1.5-7.5"/>
            </svg>
          </div>
          <div class="stat-card__value">{{ stat.value }}</div>
          <div class="stat-card__label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </section>
</template>
